const Contacts = () => {
  return (
    <section id="featured-services" className="featured-services section light-background">
      {/* Section Title */}
      <div className="container section-title" data-aos="fade-up">
        <p><span>Contattaci</span></p>
        <small>Siamo pronti a collaborare con istituzioni pubbliche, operatori di sicurezza e organizzazioni allineate al programma STEP.</small>
      </div>{/* End Section Title */}
      <div className="container text-center">
        <div className="row gy-4">
          <div className="col-xl-4 col-md-4" data-aos="fade-up" data-aos-delay={100}>
            <div className="service-item position-relative">
              <h4><a href="https://maps.google.com/maps?width=100%25&amp;height=300&amp;hl=en&amp;q=Contrada Giuliano SNC, 95011 Calatabiano - Sicilia, Italia&amp;t=&amp;z=14&amp;ie=UTF8&amp;iwloc=B&amp;" target="_blank" rel="noopener noreferrer" className="stretched-link">Sede Operativa</a></h4>
              <p>Contrada Giuliano SNC, 95011<br />Calatabiano - Sicilia, Italia</p>
            </div>
          </div>{/* End Service Item */}
          <div className="col-xl-4 col-md-4" data-aos="fade-up" data-aos-delay={200}>
            <div className="service-item position-relative">
              <h4><a href="mailto:zsolutions@pec.it" target="_blank" rel="noopener noreferrer" className="stretched-link">PEC Istituzionale</a></h4>
              <p>zsolutions@pec.it</p>
            </div>
          </div>{/* End Service Item */}
          <div className="col-xl-4 col-md-4" data-aos="fade-up" data-aos-delay={300}>
            <div className="service-item position-relative">
              <h4><a href="mailto:contact@zsolution.org" target="_blank" rel="noopener noreferrer" className="stretched-link">Amministrazione</a></h4>
              <p>contact@zsolution.org</p>
            </div>
          </div>{/* End Service Item */}
        </div>
      </div>
    </section>
  );
}
export default Contacts;